import { useQuery } from '@tanstack/react-query';
import { mailTemplatesService } from '../services/mail-templates.service';

export function useMailTemplates(productId: number, params?: Record<string, any>) {
  return useQuery({
    queryKey: ['mail-templates', productId, params],
    queryFn: () => mailTemplatesService.list({ productId, ...params }),
    enabled: !!productId,
  });
}

export function useMailTemplate(id: number) {
  return useQuery({
    queryKey: ['mail-templates', id],
    queryFn: () => mailTemplatesService.getById(id),
    enabled: !!id,
  });
}
